import {queryOptions} from '@tanstack/react-query';
import type {User} from '@/entities/User/types/user';
import {api} from '@/libs/baseApi';
import type {TLastFinishedCompetition} from '../types/TLastFinishedCompetition';
import {leaderBoardsKeys} from './leaderBoardsKeys';

export const getLastFinishedCompetitionOptions = (userId?: User['id'] | null) =>
  queryOptions<TLastFinishedCompetition | null>({
    queryKey: leaderBoardsKeys.lastFinished(),
    queryFn: async () => {
      if (!userId) {
        return null;
      }
      const apiClient = await api();

      const response = await apiClient.get<TLastFinishedCompetition>('/competitions/last-finished');
      return response.data ?? null;
    },
    enabled: !!userId,
  });
